<template>
  <div class="return-visit">
    <el-button
      type="warning"
      @click="printHandler"
      style="position: fixed;right: 20px;top: 10px;"
    >打印</el-button>
    <div id="print" style="width: 21cm;margin:0 auto">
      <div class="hx_title" style="text-align:center">中国化学工程集团公司</div>
      <div class="hx_title" style="text-align:center">因公出国（境）人员归国回访记录表</div>
      <!-- <div>
        <p class="header">中国化学工程集团有限公司</p>
      </div> -->
      <table
        cellspacing="0"
        cellpadding="0"
        border="1px solid #000"
        style="border-collapse:collapse; margin: 0 auto"
      >
        <tbody>
          <tr style="height:26pt">
            <td colspan="2" style="width: 110.1pt">
              <p>姓名</p>
            </td>
            <td colspan="2">
              <input type="text" v-model="info.leaderName">
            </td>
            <td colspan="2" style="width: 110.1pt">
              <p style="padding: 0 5pt" class="mgc">
                <span style="display: block;">涉密岗位及</span>
                <span>涉密等级</span>
              </p>
            </td>
            <td colspan="6" style="width:223.15pt">
              <input type="text" v-model="info.secret">
            </td>
            <td style="width: 50pt">
              <p style="padding:0 5pt" class="mgc">
                <span style="display: block;">政治</span>
                <span>面貌</span>
              </p>
            </td>
            <td colspan="2" id="mgc-td">
              <input type="text" style="width: 60pt">
            </td>
          </tr>
          <tr style="height:26pt">
            <td colspan="2" style="width: 132.1pt">
              <p style="padding: 0 5pt" class="mgc">
                <span style="display: block;">因公出国（境）</span>
                <span>批件号</span>
              </p>
            </td>
            <td colspan="4" style="width: 100.1pt">
<!--                <p style="word-wrap:break-word;font-size: 12pt;" >{{info.groupBatchNo}}</p>-->
               <input v-model="info.groupBatchNo" type="textarea" autosize style="text-align: center;font-family: 宋体;line-height: 14pt;">
            </td>
            <td colspan="1" style="width: 60.1pt">
              <p style="padding: 0 5pt" class="mgc">
                <span style="display: block;">同行其</span>
                <span>他人员</span>
              </p>
            </td>
            <td colspan="7" style="width: 200.1pt">
              <input type="text" v-model="info.others">
            </td>
          </tr>
          <tr style="height: 70pt;">
            <td colspan="2" style="width: 110.1pt">
              <p>证件类型</p>
            </td>
            <td colspan="2" style="width: 110.1pt;height: 90pt;">
              <div class="certificate-radio certificate-local">
                <input type="radio" id="dewey50" name="huey50" value="dewey50">
                <label for="dewey50">因公护照</label>
              </div>
              <div class="certificate-radio certificate-local2">
                <input type="radio" id="dewey51" name="huey50" value="dewey51">
                <label for="dewey51">港澳通行证</label>
              </div>
              <div class="certificate-radio certificate-local3">
                <input type="radio" id="dewey52" name="huey50" value="dewey52">
                <label for="dewey52">台湾通行证</label>
              </div>
              <div class="certificate-radio certificate-local4">
                <input type="radio" id="dewey53" name="huey50" value="dewey53">
                <label for="dewey53">其他</label>
              </div>
            </td>
            <td colspan="2" style="width: 110.1pt">
              <p>证件号码</p>
            </td>
            <td colspan="8" style="width:123.85pt">
              <input type="text" style="font-family: 宋体" v-model="passportNo">
            </td>
          </tr>
          <tr style="height:26pt">
            <td colspan="2" style="width: 110.1pt">
              <p style="padding: 0 5pt" class="mgc">
                <span style="display: block;">出国（境）</span>
                <span>起止时间</span>
              </p>
            </td>
            <td colspan="12" style="width:100pt">
              <div style="display: flex;margin-left: 10pt;">
                <input type="text" style="width: 32%;">
                <span>年</span>
                <input type="text" style="width: 30%;">
                <span>月</span>
                <input type="text" style="width: 30%;">
                <span>日</span>
                <span>至</span>
                <input type="text" style="width: 32%;">
                <span>年</span>
                <input type="text" style="width: 30%;">
                <span>月</span>
                <input type="text" style="width: 30%;">
                <span style="padding-right: 90pt;">日</span>
              </div>
            </td>
          </tr>
          <tr style="height:26pt">
            <td colspan="2" style="width:110.1pt">
              <p style="padding: 0 5pt" class="mgc">
                <span style="display: block;">出国（境）</span>
                <span>行程</span>
              </p>
            </td>
            <td colspan="12" style="width:100pt">
              <input type="text" v-model="info.visitCountryNames"  style="font-family: 宋体">
            </td>
          </tr>
          <tr style="height: 35pt;">
            <td colspan="14">
              <div style="text-align: center;">回访调查事项</div>
              <p style="text-align: left;padding-left: 10pt;">1. “我方人员”含本人及团组其他人员。</p>
              <p style="text-align: left;padding-left: 10pt;">2. 3-32 项如填“是”，请将具体情况在“其他需要说明的情况”一栏中一并详细说明。</p>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        cellspacing="0"
        cellpadding="0"
        border="1px solid #000"
        style="border-collapse:collapse; margin: 0 auto"
        class="visit-table"
      >
        <tbody>
          <tr>
            <td colspan="1" width="50pt">
              <p>1</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>办理签证过程是否顺利？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey" name="huey" value="huey">
                  <label for="huey">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey" name="huey" value="dewey">
                  <label for="dewey">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>2</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>所在团组或成员是否按照原定计划按时回国？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey2" name="huey2" value="huey2">
                  <label for="huey2">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey2" name="huey2" value="dewey2">
                  <label for="dewey2">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>3</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>办理签证过程中是否接到驻华使领馆人员等外方人员电话？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey3" name="huey3" value="huey3">
                  <label for="huey3">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey3" name="huey3" value="dewey3">
                  <label for="dewey3">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>4</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>办理签证的过程中是否接受过外方的查访？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey4" name="huey4" value="huey4">
                  <label for="huey4">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey4" name="huey4" value="dewey4">
                  <label for="dewey4">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>5</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>通知面试时外方是否提过异常要求？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey5" name="huey5" value="huey5">
                  <label for="huey5">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey5" name="huey5" value="dewey5">
                  <label for="dewey5">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>6</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>面试时签证官是否提问敏感话题？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey6" name="huey6" value="huey6">
                  <label for="huey6">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey6" name="huey6" value="dewey6">
                  <label for="dewey6">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>7</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>签证官是否提出过不合常规或其他苛刻要求？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey7" name="huey7" value="huey7">
                  <label for="huey7">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey7" name="huey7" value="dewey7">
                  <label for="dewey7">否</label>
              </div>
            </td>
          </tr>
          <tr class="given-tr">
            <td colspan="1" width="50pt">
              <p>8</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>是否有我方人员被海关或其他执法部门盘查、骚扰、查验行李，以及托运行李被翻动等情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey8" name="huey8" value="huey8">
                  <label for="huey8">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey8" name="huey8" value="dewey8">
                  <label for="dewey8">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>9</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>是否有我方人员与外方人员交往密切或其他异常情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey9" name="huey9" value="huey9">
                  <label for="huey9">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey9" name="huey9" value="dewey9">
                  <label for="dewey9">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>10</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>是否有按照对方要求，将手机、电脑等电子产品放到对方制定区域的情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey10" name="huey10" value="huey10">
                  <label for="huey10">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey10" name="huey10" value="dewey10">
                  <label for="dewey10">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>11</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>外方是否有了解与我出访任务无关的涉我情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey11" name="huey11" value="huey11">
                  <label for="huey11">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey11" name="huey11" value="dewey11">
                  <label for="dewey11">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>12</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>出国（境）期间，是否有我方人员接受外方馈赠贵重礼品的情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey12" name="huey12" value="huey12">
                  <label for="huey12">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey12" name="huey12" value="dewey12">
                  <label for="dewey12">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>13</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>出国（境）期间，外方是否安排与公务活动无关的娱乐活动？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey13" name="huey13" value="huey13">
                  <label for="huey13">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey13" name="huey13" value="dewey13">
                  <label for="dewey13">否</label>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>14</p>
            </td>
            <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>出国（境）期间，是否有我方人员出现情绪异常、消费异常的情况？</span>
            </td>
            <td colspan="1" style="border-left:none;border-right:none" width="50pt">
              <div class="radio">
                  <input type="radio" id="huey14" name="huey14" value="huey14">
                  <label for="huey14">是</label>
              </div>
            </td>
            <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
              <div class="radio">
                  <input type="radio" id="dewey14" name="huey14" value="dewey14">
                  <label for="dewey14">否</label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="display:flex;margin: 200px auto auto 0;">
        <table
          cellspacing="0"
          cellpadding="0"
          border="1px solid #000"
          style="border-collapse:collapse; margin: 0 auto"
          class="visit-table"
        >
          <tr>
            <td colspan="1" width="50pt">
              <p>15</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，是否有我方人员脱团私自活动、晚归、夜不归宿等情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey15" name="huey15" value="huey15">
                    <label for="huey15">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey15" name="huey15" value="dewey15">
                    <label for="dewey15">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>16</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，住宿、就餐、会谈时是否有发现被窃听、窃照的情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey16" name="huey16" value="huey16">
                    <label for="huey16">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey16" name="huey16" value="dewey16">
                    <label for="dewey16">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>17</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，行李、电脑、手机等个人物品是否有被私下翻动、检查的情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey17" name="huey17" value="huey17">
                    <label for="huey17">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey17" name="huey17" value="dewey17">
                    <label for="dewey17">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>18</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，是否发生国（境）外组织或个人主动与我方人员接触、攀谈的情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey18" name="huey18" value="huey18">
                    <label for="huey18">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey18" name="huey18" value="dewey18">
                    <label for="dewey18">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>19</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，我方人员是否有被执法部门约谈、查验护照、强行带离等情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey19" name="huey19" value="huey19">
                    <label for="huey19">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey19" name="huey19" value="dewey19">
                    <label for="dewey19">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>20</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，是否发生过其他与我方人员安全相关的问题？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey20" name="huey20" value="huey20">
                    <label for="huey20">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey20" name="huey20" value="dewey20">
                    <label for="dewey20">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>21</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间是否发生我方人员遗失个人证照的情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey21" name="huey21" value="huey21">
                    <label for="huey21">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey21" name="huey21" value="dewey21">
                    <label for="dewey21">否</label>
                </div>
              </td>
          </tr>
          <tr class="given-tr">
            <td colspan="1" width="50pt">
              <p>22</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间，是否携带涉密文件、资料以及记录有涉密内容的便携式电脑或移动存储介质出国（境）？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey22" name="huey22" value="huey22">
                    <label for="huey22">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey22" name="huey22" value="dewey22">
                    <label for="dewey22">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>23</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>在国（境）外的工作场所、公共场所、所住酒店等场所是否谈论涉密事项？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey23" name="huey23" value="huey23">
                    <label for="huey23">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey23" name="huey23" value="dewey23">
                    <label for="dewey23">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>24</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>在国（境）外期间，工作中通过互联网发送的邮寄内容是否涉及涉密事宜？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey24" name="huey24" value="huey24">
                    <label for="huey24">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey24" name="huey24" value="dewey24">
                    <label for="dewey24">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>25</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>在出国（境）期间，是否参与过宗教、邪教组织的活动，是否接受过相关资料？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey25" name="huey25" value="huey25">
                    <label for="huey25">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey25" name="huey25" value="dewey25">
                    <label for="dewey25">否</label>
                </div>
              </td>
          </tr>
          <tr class="given-tr">
            <td colspan="1" width="50pt">
              <p>26</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>是否有国（境）外人员索要与此次公务活动无关的资料，或打探索要本单位其他内部资料、人员动向、单位信息等情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey26" name="huey26" value="huey26">
                    <label for="huey26">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey26" name="huey26" value="dewey26">
                    <label for="dewey26">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>27</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>是否有我方人员私自接受过媒体的采访？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey27" name="huey27" value="huey27">
                    <label for="huey27">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey27" name="huey27" value="dewey27">
                    <label for="dewey27">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>28</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>回国后是否有我方人员接到过驻华使领馆官员的电话？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey28" name="huey28" value="huey28">
                    <label for="huey28">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey28" name="huey28" value="dewey28">
                    <label for="dewey28">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>29</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>回国后，是否有与外方人员继续联系的情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey29" name="huey29" value="huey29">
                    <label for="huey29">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey29" name="huey29" value="dewey29">
                    <label for="dewey29">否</label>
                </div>
              </td>
          </tr>
          <tr class="given-tr">
            <td colspan="1" width="50pt">
              <p>30</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>出国（境）期间及回国后手机有无异常，如有无收到附链接的可以短信，并要求点击等情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey30" name="huey30" value="huey30">
                    <label for="huey30">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey30" name="huey30" value="dewey30">
                    <label for="dewey30">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>31</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>机票、证照上是否出现被特殊标记情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey31" name="huey31" value="huey31">
                    <label for="huey31">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey31" name="huey31" value="dewey31">
                    <label for="dewey31">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>32</p>
              </td>
              <td colspan="17" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>其他同行人员是否存在其他异常情况？</span>
              </td>
              <td colspan="1" style="border-left:none;border-right:none" width="50pt">
                <div class="radio">
                    <input type="radio" id="huey32" name="huey32" value="huey32">
                    <label for="huey32">是</label>
                </div>
              </td>
              <td colspan="1" style="border-left:none;border-right:none;margin:0 10pt 0 0;" width="50pt">
                <div class="radio">
                    <input type="radio" id="dewey32" name="huey32" value="dewey32">
                    <label for="dewey32">否</label>
                </div>
              </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>33</p>
            </td>
            <td colspan="19" width="300pt" style="border-right:1px solid grey;" class="txl set-boder">
              <span>外方接待人员，以及翻译、导游、医护、安保、随团记者等其他陪同人员基本情况？</span>
            </td>
          </tr>
          <tr>
            <td colspan="20" width="300pt" style="border-right:1px solid grey;" class="txl">
              <div class="content-area">
                <input type="text">
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
            <p>34</p>
            </td>
            <td colspan="19" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>与外方交流的主要情况？</span>
            </td>
          </tr>
          <tr>
            <td colspan="20" width="300pt" style="border-right:1px solid grey;" class="txl">
              <div class="content-area">
                <input type="text">
              </div>
            </td>
          </tr>

        </table>
      </div>

      <div style="display:flex;margin: 200px auto auto 0;">
        <table
          cellspacing="0"
          cellpadding="0"
          border="1px solid #000"
          style="border-collapse:collapse; margin: 0 auto"
        >
          <tr>
            <td colspan="1" width="50pt">
              <p>35</p>
              </td>
              <td colspan="19" width="300pt" style="border-right:1px solid grey;" class="txl">
                <span>与当地华人华侨或其他在当地生活、工作、学习的中国人接触、交往情况？</span>
              </td>
          </tr>
          <tr>
            <td colspan="20" width="300pt" style="border-right:1px solid grey;" class="txl">
              <div class="content-area">
                <input type="text">
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="1" width="50pt">
              <p>36</p>
            </td>
            <td colspan="19" width="300pt" style="border-right:1px solid grey;" class="txl">
              <span>其他需说明的情况？</span>
            </td>
          </tr>
          <tr>
            <td colspan="20" width="300pt" style="border-right:1px solid grey;" class="txl">
              <div class="content-area">
                <input type="text">
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="promise-box">
        <p class="promise-box-title">本人承诺，以上填写均符合实际，如有隐瞒，愿意承担党纪、政务和法律责任。</p>
        <p class="promise-second">被访谈人签字：</p>
        <div class="clearfix"></div>
        <p class="promise-third">
          <input type="text" v-model="year">
          <span>年</span>
          <input type="text" v-model="month">
          <span>月</span>
          <input type="text" v-model="day">
          <span>日</span>
        </p>
      </div>
      <div class="promise-box">
        <p class="interview-title">访谈人签字：</p>
        <div class="clearfix"></div>
        <p class="promise-third">
          <input type="text" v-model="year">
          <span>年</span>
          <input type="text" v-model="month">
          <span>月</span>
          <input type="text" v-model="day">
          <span>日</span>
        </p>
      </div>

    </div>
    <el-row type="flex" justify="space-around">
      <el-button type="warning" @click="printHandler" style="width: 400px;font-size: 24px">打印</el-button>
    </el-row>
    <div style="text-align: center">
      <span>版权所有：中国化学工程集团(股份)有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17025820号-5</a> | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span>
    </div>
  </div>
</template>
<script>
import print from "print-js";
import SetupApi from "../../api/setup";
import {mapGetters} from "vuex";
let Api = new SetupApi();
export default {
  name: "returnVisit",
  computed: {
    ...mapGetters(["versionNumber"])
  },
  data() {
    return {
      info: {},
      date: new Date(),
      visitInfo:{},
      year: "",
      month: "",
      day: "",
      passportNo:"",
    };
  },
  methods: {
    printHandler() {
      this.$confirm("该页面请双面打印!").then(() => {
        print({
          printable: "print",
          type: "html",
          scanStyles: false,
          css: ["/static/print/returnTable.css"],

        });
      });
    }
  },
  mounted() {
    if (this.$route.query.id) {
      Api.getOverview({ itemInfoId: this.$route.query.id }).then(res => {
        this.info = res.data.stateItemInfo;
        this.info.leaderName = this.info.firstName + this.info.lastName;
        let {entryDate,depaDate,entryCity,visitReason} = res.data.visitInfoList[0];
        this.visitInfo = {entryDate:`${entryDate} —— ${depaDate}`,entryCity,visitReason};
        this.info.leaderName = this.info.firstName + this.info.lastName;
        let target = res.data.personInfoList.find(
          a => a.name === this.info.leaderName
        );

        if (target) {
          this.info.sex = target.sex === "M" ? "男" : "女";
          this.info.cardNo = target.cartNo;

          if(target.secret === 'Y'){
            if(target.secretType === 'LEVELONE_CLASSIFIED'){
              this.info.secret = '重要涉密岗位，重要涉密等级';
            }else if(target.secretType === 'SECONDARY_CLASSIFIED') {
              this.info.secret = '一般涉密岗位，一般涉密等级';
            }
          } else {
            this.info.secret = '不涉密';
          }
          this.info.birthday = target.birthday;
          this.info.duty = target.duty;
          this.info.visitCountryNames = target.visitCountryNames;
          let strArr = this.info.visitCountryName.split("、");
          if(strArr.length > 3) {
            this.info.visitCountryName = `${strArr[0]}、${strArr[1]}、${strArr[2]}等`;
          }
        }
        this.info.others = res.data.personInfoList.map(a => a.name).join("、");
        this.info.visitCountryNames = res.data.visitInfoList
          .map(a => a.visitCountryName)
          .join(",");
        let passport = res.data.personInfoList.find(item => item.birthday === this.info.birthday).passports;
        this.passportNo = passport.length ? passport[0].passportNo : '';
      });
    }
    this.year = this.date.getFullYear();
    this.month = this.date.getMonth() + 1;
    this.day = this.date.getDate();
  }
};
</script>
<style lang="scss" scoped>
#print {
  font-family: 宋体;
  table + table {
    border-top: none;
  }
  .content-card:first-of-type{
    margin-top: 30pt;
  }
  .content-card {
    border: 1px solid #000;
    font-size: 12pt;
  }
  .content-card + .content-card {
    border-top: none;
  }
  .label-row {
    display: flex;
    height: 26pt;
    border-bottom: 1px solid #000;
    line-height: 26pt;
  }
  .label-box {
    border-right: 1px solid #000;
    width: 4cm;
    text-align: center;
  }
  .content-area {
    height: 100pt;
  }
  .label-content {
    flex: 1;
    padding-left: 5pt;
    height: 26pt;
    line-height: 26pt;
  }
  textarea {
    height: 90%;
    width: 90%;
    margin: 1pt;
    border: none;
    outline: none;
    font-weight: bold;
    font-size: 10pt;
  }
  .passport-n {
    padding: 6% 0 0 0
  }
  .promise-card {
    height: 110pt;
  }
  .promise-card p:first-child {
    font-weight: bold;
    font-size: 18pt;
    margin: 0 0 20pt 10pt;
  }
  .promise-card p:nth-child(2) {
    width: 10cm;
    float: right;
    text-align: left;
  }
  .clearfix{
    width: 100%;
    clear: both;
  }
  .promise-card p:last-child {
    float: right;
    margin-right: 30pt;
  }
  .promise-card input {
    width: 1cm;
    border: none;
    outline: none;
    text-align: center;
  }
  .promise-text{
    text-indent: 2em;
  }
  .promise-box {
    height: 160pt !important;
    padding-left: 10pt;
    box-sizing: border-box;
    border: 1px solid #000;
  }
  .promise-box .promise-box-title {
    padding: 20pt 0;
    box-sizing: border-box;
    font-family: 宋体;
  }
  .promise-box .promise-second {
    padding-top: 10pt;
    box-sizing: border-box;
    font-family: 宋体;
  }
  .promise-box .promise-third {
    float: right;
    margin-right: 30pt;
    font-family: 宋体;
  }
  .promise-box .interview-title{
    padding: 60pt 0 20pt 0;
    box-sizing: border-box;
    font-family: 宋体;
  }
  .promise-box input {
    width: 1cm;
    border: none;
    outline: none;
    text-align: center;
  }
}

#print table {
  width: 100%;
  font-family: 宋体;
}

#print table td,
#print table th {
  height: 26pt;
  text-align: center;
  font-family: 宋体;
  line-height: 14pt;
  vertical-align: middle;
}

#print table td input {
  border: 0px solid transparent;
  width: 95%;
  height: 18pt;
  font-size: 12pt;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  line-height: 41px;
}
#print .label {
  float: left;
  height: 100%;
  line-height: 26pt;
}
#print .append {
  width: 15cm;
  float: left;
  height: 100%;
  line-height: 26pt;
}
#print .txc {
  text-align: center;
}
#print .txl {
  padding-left: 10pt;
  text-align: left;
}

#print .radio{
   position: relative;
    display: inline-block;
    margin-right: 12px;
}

#print .radio input[type="radio"] {
   display:none;
}

#print .radio label {
    position: absolute;
    left: -8px;
    top: -10px;
    width: 15px;
    height: 15px;
}

#print .radio label::before {
  display: inline-block;
  content:'';
  width: 16px;
  height: 16px;
  border: 1px solid black;
  position: absolute;
  left:16px;
  top:1px;
  vertical-align: bottom;
}



#print .radio input:checked+label::after {
    content: "";
    position: absolute;
    left:21px;
    top: 0px;
    /* 这里显示矩形的一半边框再旋转45度来实现对勾样式 */
    width: 5px;
    height: 12px;
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    transform: rotate(45deg);
}

#print .certificate-radio{
  position: relative;
  display: inline-block;
  margin-right: 12pt;
}
#print .certificate-radio input[type="radio"] {
  display: none !important;
}
#print .certificate-radio label {
  position: absolute;
  left: 1pt;
  top: -10pt;
  width: 60pt;
  height: 16pt;
}
#print .certificate-radio label::before {
  display: inline-block;
  content:'';
  width: 12pt;
  height: 12pt;
  border: 1pt solid black;
  position: absolute;
  left: -16pt;
  top: 1pt;
  vertical-align: bottom;
}
#print .certificate-radio input:checked+label::after {
  content: "";
  position: absolute;
  left: 21pt;
  top: 0pt;
  /* 这里显示矩形的一半边框再旋转45度来实现对勾样式 */
  width: 4pt;
  height: 10pt;
  border-right: 1pt solid #000000;
  border-bottom: 1pt solid #000000;
  transform: rotate(45deg);
}
#print .certificate-local label {
  top: -38pt;
  left: 1pt;
}
#print .certificate-local input:checked+label::after {
  left: -11pt;
  top: 0pt;
}
#print .certificate-local2 label {
  top: -20pt;
  left: -4pt;
}
#print .certificate-local2 label::before{
  left: -23pt;
}
#print .certificate-local2 input:checked+label::after {
  left: -18pt;
  top: 0pt;
}
#print .certificate-local3 label {
  top: -2pt;
  left: -17pt;
}
#print .certificate-local3 label::before{
  left: -22pt;
}
#print .certificate-local3 input:checked+label::after {
  left: -17pt;
  top: 0pt;
}
#print .certificate-local4 label {
  top: 15pt;
  left: -47pt;
}
#print .certificate-local4 label::before{
  left: -4pt;
}
#print .certificate-local4 input:checked+label::after {
  left: 1pt;
  top: 0pt;
}

 #print .promise-footer{
    width:100%;
    height:100pt;
    border:1px solid grey;
    display:flex;
  }


 #print .promise-footer-left{
    width:30%;
    height:100pt;
    line-height: 100pt;
    font-weight: bold;
    border-right:1px solid grey;
    text-align:left;
    text-indent: 1em;
  }



 #print .promise-footer-right .date{
    padding: 35pt 0 0 150pt;
  }


 #print .promise-footer-right input{
    width: 1cm;
    /* font-size: 12pt; */
    line-height: 14pt;
    text-align: center;
    border: none;
    outline: none;
  }


  #print  .promise-footer-right{
    display: flex
  }
  #print .promise-footer-right .text{
    padding: 35pt 0 0 5pt;
  }

  #print /deep/ .el-textarea__inner {
    resize: none;
    line-height: normal;
    min-height: 28px !important;
    overflow-y: hidden;
    border: unset;
  }

</style>

